<script>
    import ModalEquipment from '../modal/modalEquipment.svelte'
    import { Temperaments } from '../../../script/_data'
    import { CheckLink, CheckMonsterData } from '../../../script/handle/write'

    export let Monster, Temperament, Equipment
    let ShowEquipmentModal = false
    let EquipmentPosition = -1
    let clientWidth, clientHeight
    
    // 기질 선택
    function clickTemperament() {
        CheckMonsterData()
    }

    // 장비 선택 Modal 호출
    function callEquipmentModal(_position) {
        ShowEquipmentModal = true
        EquipmentPosition = _position
    }
</script>

<div class='temperament'>
    <div class="tag">추천 기질 </div>
    <select bind:value={Temperament} on:change={() => clickTemperament()}>
        <option value={-1}>미선택</option>
        {#each Temperaments as temper, i}
            <option value={i}>{temper.name}</option>
        {/each}
    </select>
</div>

<div class="bar"></div>

<div class="equipment">
    <div class="tag">추천 장비 </div>
    <div class="list">
        {#each Equipment as item, i}
            <div
                class="item" bind:clientWidth bind:clientHeight
                on:click={() => callEquipmentModal(i)}
            >
                <img
                    class='equip'
                    src="{CheckLink()}/img/equipment/equip/{item}.png"
                    alt="equip_{item}"
                >
            </div>
        {/each}

        {#if Equipment.length < 3}
            <div class='btn' class:zero={Equipment.length == 0}>
                <svg xmlns="http://www.w3.org/2000/svg" class='top' width="25" height="18" viewBox="0 0 25 18" fill="none">
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M24.2613 4.85226L19.1537 0H-4.88758e-06V4.85226H2.82704e-05V12.3063L4.85229 17.4139L4.85229 4.85226H24.2613Z" fill="#7A67FF"/>
                </svg>

                <svg xmlns="http://www.w3.org/2000/svg" class='bottom' width="25" height="18" viewBox="0 0 25 18" fill="none">
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M4.57764e-05 12.5618L5.10769 17.4141H24.2614V12.5618H24.2613V5.10781L19.4091 0.000162125L19.4091 12.5618H4.57764e-05Z" fill="#7A67FF"/>
                </svg>

                <button
                    on:click={() => callEquipmentModal(-1)}
                    style="width: {clientWidth}px; height: {clientHeight}px;"
                >
                    추가
                </button>
            </div>
        {/if}
    </div>
</div>

{#if ShowEquipmentModal}
    <ModalEquipment
        bind:Monster bind:ShowEquipmentModal bind:Position={EquipmentPosition}
    />
{/if}

<style lang="scss">
    .temperament {
        width: calc(100%);
        height: fit-content;

        .tag {
            font-size: 15px;
            font-family: aggro;
            display: inline-block;
        }
        select {
            display: inline-block;
        }
    }

    .bar {
        background: $cl3;
        width: 100%;
        height: 1px;
        margin-top: 8px;
        margin-bottom: 10px;
    }

    .equipment {
        width: calc(100%);
        height: fit-content;

        .tag {
            font-size: 15px;
            font-family: aggro;
        }
        .list {
            width: calc(100%);
            height: fit-content;

            .item {
                width: calc(33% - 20px - 20px - 4px);
                height: fit-content;
                margin: 10px;
                padding: 10px;
                border: 2px solid $cl1;
                display: inline-block;
                vertical-align: top;

                &:hover {
                    border: 2px solid $cl3;
                    cursor: pointer;
                }

                img { width: 100%; }
            }

            .btn {
                width: calc(33% - 20px - 4px);
                height: 100%;
                margin: 10px;
                padding: 3px 4px;
                position: relative;
                display: inline-block;

                &.zero { width: calc(100% - 20px - 8px); }
                
                svg {
                    position: absolute;

                    &.top {
                        top: 0;
                        left: 0;
                    }

                    &.bottom {
                        bottom: 0;
                        right: 0 ;
                    }
                }

                button {
                    background: none;
                    width: calc(100%);
                    height: 100%;
                    padding-top: 10px;
                    padding-bottom: 5px;
                    border: 2px solid $cl3;
                    color: #FFFFFF;
                    font-size: 18px;
                    font-family: aggro;
                    vertical-align: top;

                    &:hover {
                        background: $cl3;
                    }
                }
            }
        }
    }
</style>